import React, { useContext } from 'react'
import { StyledJobOffersContainer, JobOffersContainerProps } from './styled'
import { SessionContext } from 'spa/App'
const Index: React.FC<JobOffersContainerProps> = (props: JobOffersContainerProps) => {
  const session = useContext(SessionContext); // セッション情報を取得

  return (
    <StyledJobOffersContainer {...props} session={session} />
  )
}

export default Index
